import styled from 'styled-components';

import {breakpoint, colors, font} from 'theme';

export const ModalContentErrors = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    height: fit-content;
    overflow-y: auto;
    max-height: 230px;
`;

export const ModalContentErrorsOverflow = styled.div`
    font-size: 14px;
    color: ${colors.black};
    text-align: left;
    width: 100%;
    margin-top: 30px;
`;

export const ModalContentErrorItem = styled.div`
    display: grid;
    grid-template-columns: 85px 1fr;
    gap: 8px;
    width: 100%;
    height: fit-content;
    align-items: flex-start;
`;

export const ModalContentErrorItemIndex = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.black};
`;

export const ModalContentErrorItemErrors = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
    justify-content: center;
    font-size: 14px;
    color: ${colors.black};
`;

export const ButtonWrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 0;
    width: 100%;
`;

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: fit-content;
`;

export const ModalContentWrapper = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 16px;
`;

export const Root = styled.div<{isDrag: boolean}>`
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 50%;
    height: 100%;
    min-height: 110px;
    font-size: 12px;
    border: ${(p) => (p.isDrag ? '1px solid #cccccc' : '1px dashed #cccccc')};
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
    outline: none;
    text-align: center;

    &:hover {
        border: ${(p) => p.isDrag && '1px solid #cccccc'};
    }
`;

export const RootContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    height: auto;
    > p {
        margin: 0;
        padding: 0;
    }
`;

export const HighlightedText = styled.span`
    color: ${colors.brandPrimary};
`;

export const FileExample = styled.div`
    box-sizing: border-box;
    gap: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    width: 50%;
    height: auto;

    > span {
        color: ${colors.black};
        font-family: ${font.family.primary};
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0;
        text-align: center;
    }

    > a {
        color: ${colors.brandPrimary};
        font-family: ${font.family.primary};
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0;
        text-align: center;
    }
`;
